// extracted by mini-css-extract-plugin
export var measureBox = "_a7-0";